import React from 'react';
import PropTypes from 'prop-types';
import { ALIGNMENTS, Icon, PLACEMENTS, TooltipWrapper } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import styles from './LegendInfo.css';

function LegendInfo({ contentStringKey, titleStringKey, layer }) {
  return (
    <div className={`${styles.help}`}>
      <TooltipWrapper
        alignment={ALIGNMENTS.END}
        content={[getMessage(contentStringKey || `legend.${layer}`)]}
        mode="secondary"
        placement={PLACEMENTS.LEFT}
        testId="legend-tooltip-wrapper"
        title={getMessage(titleStringKey || layer)}
      >
        <a>
          <Icon glyph={Icon.set.INFO_CIRCLE} testId="legend-tooltip-icon" />
        </a>
      </TooltipWrapper>
    </div>
  );
}

LegendInfo.propTypes = {
  contentStringKey: PropTypes.string,
  layer: PropTypes.string,
  titleStringKey: PropTypes.string,
};

export default LegendInfo;
